export default __webpack_public_path__ + "static/media/modal-cross.359b9bec.svg";